/**
 * @public
 * Determines whether the input parameter is not an `Object` or an `Array`
 *
 * @param  {any} value: the value to test
 * @return {Boolean}
 */
const isNotObject = value => value === null || typeof value !== 'object';

export default isNotObject;
